import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FAIcon from "../FAIcon/FAIcon";
const HelpIcon = ({ size, onClick, title }) => {
    const safeTitle = title || "Show Help";
    const icon = (_jsx(FAIcon, { size: size, icon: "question-circle", className: "btn-link", title: safeTitle, type: "far", style: { textDecoration: "none" } }));
    if (onClick) {
        return (_jsxs("button", { className: "btn btn-link p-0", onClick: onClick, title: safeTitle, type: "button", children: [icon, _jsx("span", { className: "sr-only", children: safeTitle })] }));
    }
    return icon;
};
export default HelpIcon;
